import * as yup from 'yup';

// Auth validation schemas
export const loginSchema = yup.object({
  email: yup
    .string()
    .email('Please enter a valid email address')
    .required('Email is required'),
  password: yup
    .string()
    .required('Password is required'),
});

export const registerSchema = yup.object({
  name: yup
    .string()
    .trim()
    .min(1, 'Name is required')
    .max(100, 'Name must be less than 100 characters')
    .required('Name is required'),
  email: yup
    .string()
    .email('Please enter a valid email address')
    .required('Email is required'),
  password: yup
    .string()
    .min(6, 'Password must be at least 6 characters')
    .required('Password is required'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password')], 'Passwords must match')
    .required('Please confirm your password'),
  age: yup
    .number()
    .min(1, 'Age must be at least 1')
    .max(150, 'Age must be less than 150')
    .optional(),
  gender: yup
    .string()
    .oneOf(['male', 'female', 'other', 'prefer_not_to_say'], 'Please select a valid gender')
    .optional(),
});

export const forgotPasswordSchema = yup.object({
  email: yup
    .string()
    .email('Please enter a valid email address')
    .required('Email is required'),
});

export const resetPasswordSchema = yup.object({
  password: yup
    .string()
    .min(6, 'Password must be at least 6 characters')
    .required('Password is required'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password')], 'Passwords must match')
    .required('Please confirm your password'),
});

// User profile validation schemas
export const profileSchema = yup.object({
  name: yup
    .string()
    .trim()
    .min(1, 'Name is required')
    .max(100, 'Name must be less than 100 characters')
    .required('Name is required'),
  age: yup
    .number()
    .min(1, 'Age must be at least 1')
    .max(150, 'Age must be less than 150')
    .optional(),
  gender: yup
    .string()
    .oneOf(['male', 'female', 'other', 'prefer_not_to_say'], 'Please select a valid gender')
    .optional(),
});

export const changePasswordSchema = yup.object({
  currentPassword: yup
    .string()
    .required('Current password is required'),
  newPassword: yup
    .string()
    .min(6, 'Password must be at least 6 characters')
    .required('New password is required'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('newPassword')], 'Passwords must match')
    .required('Please confirm your new password'),
});

// Family validation schemas
export const familySchema = yup.object({
  name: yup
    .string()
    .trim()
    .min(1, 'Family name is required')
    .max(100, 'Family name must be less than 100 characters')
    .required('Family name is required'),
  description: yup
    .string()
    .trim()
    .max(500, 'Description must be less than 500 characters')
    .optional(),
});

export const joinFamilySchema = yup.object({
  inviteCode: yup
    .string()
    .trim()
    .min(6, 'Invite code must be at least 6 characters')
    .max(20, 'Invite code must be less than 20 characters')
    .required('Invite code is required'),
});

// Reader validation schemas
export const readerSchema = yup.object({
  name: yup
    .string()
    .trim()
    .min(1, 'Reader name is required')
    .max(100, 'Reader name must be less than 100 characters')
    .required('Reader name is required'),
  age: yup
    .number()
    .min(1, 'Age must be at least 1')
    .max(150, 'Age must be less than 150')
    .optional(),
  gender: yup
    .string()
    .oneOf(['male', 'female', 'other', 'prefer_not_to_say'], 'Please select a valid gender')
    .optional(),
});

// Reading report validation schemas
export const reportSchema = yup.object({
  chapterId: yup
    .number()
    .required('Please select a chapter'),
  readDate: yup
    .date()
    .max(new Date(), 'Read date cannot be in the future')
    .required('Read date is required'),
  notes: yup
    .string()
    .trim()
    .max(1000, 'Notes must be less than 1000 characters')
    .optional(),
  rating: yup
    .number()
    .min(1, 'Rating must be between 1 and 5')
    .max(5, 'Rating must be between 1 and 5')
    .optional(),
});
